import styled from "styled-components";
import { convertPxToRem } from "frontend/components/helpers";

// styled-components
export const TooltipWithMessageStyled = styled.div`
    display: flex;
    align-items: center;
`;

export const TextStyled = styled.span`
    display: inline-block;
    margin-right: ${convertPxToRem({ px: 7 })};
`;
